import { Network, Organisation } from '@common/types/objects';
import { EComponentTypes } from '@common/definitions';

type ComponentTypesKeys = keyof typeof EComponentTypes;
export type ComponentTypesValues = typeof EComponentTypes[ComponentTypesKeys];

export function hasEnabledComponent(
  requiredComponent: ComponentTypesValues,
  network: Network,
  organisation: Organisation,
  isOnlyNetwork: boolean = false
) {
  if (isOnlyNetwork) {
    return network?.enabled_components?.includes(requiredComponent) || false;
  }

  const enabledComponents = [
    ...((network && network.enabled_components) || []),
    ...((organisation && organisation.enabled_components) || [])
  ];

  return enabledComponents.some((component) => component === requiredComponent);
}
